import * as React from 'react';
import { StyleProp, View, ViewStyle } from 'react-native';
import Svg, { Path } from 'react-native-svg';

const MB_SVG_TriangleRound = React.memo(
  (props: {
    /**
     * The size of the component.
     */
    size?: number;

    /**
     * The color of the component.
     */
    color?: string;

    /**
     * The style of the component's container.
     */
    containerStyle?: StyleProp<ViewStyle>;
  }) => {
    return (
      <View style={props.containerStyle}>
        <Svg width={props.size ?? 15} height={props.size ? props.size * (10 / 15) : 10} viewBox="0 0 15 10" fill="none">
          <Path d="M6.635.5a1 1 0 011.732 0l6.495 11.25a1 1 0 01-.866 1.5H1.006a1 1 0 01-.867-1.5L6.635.5z" fill={props.color ?? '#fff'} />
        </Svg>
      </View>
    );
  }
);

export { MB_SVG_TriangleRound };
